import { UnauthorizedError, type TokenStorage } from '@alter/api-client';

export type ApiErrorHandler = (error: unknown) => void;

export interface ApiErrorHandlerDeps {
  /** Solo se necesita el método `clear` — pasamos lo mínimo para facilitar tests. */
  tokenStorage: Pick<TokenStorage, 'clear'>;
  /** Reset del `authStore`. Inyectado para evitar import directo del store. */
  resetAuth: () => void;
}

/**
 * Factory del handler global de errores de la API. Se conecta a
 * `QueryCache.onError` y `MutationCache.onError` de TanStack Query — la
 * lógica de 401 vive **acá y solo acá**, los hooks individuales no la
 * replican (criterio del usuario en F0.5).
 *
 * Política:
 * - `UnauthorizedError` (HTTP 401) → `tokenStorage.clear()` + `resetAuth()`.
 *   `RequireAuth` ve `token === null` en el próximo render y redirige a `/login`
 * - Cualquier otro error → no-op acá. La UI lo recibe vía
 *   `useQuery({ error })` / `useMutation({ onError })` y muestra mensaje
 */
export function createApiErrorHandler(deps: ApiErrorHandlerDeps): ApiErrorHandler {
  return (error: unknown): void => {
    if (error instanceof UnauthorizedError) {
      void deps.tokenStorage.clear();
      deps.resetAuth();
    }
  };
}
